import request from "../api/httpClient.js";
import getEndpoint from "../utils/getEndpoint.js";

export const getAnimation = async (animationId) => {
  const animation = await request(
    getEndpoint("studio", "getAnimation", animationId),
  );
  return animation.data;
};

export const createAnimation = async (payload) => {
  const animation = await request(getEndpoint("studio", "createAnimation"), {
    body: payload,
  });
  return animation.data;
};

export const updateAnimation = async (animationId, payload) => {
  const animation = await request(
    getEndpoint("studio", "updateAnimation", animationId),
    { body: payload },
  );
  return animation.data;
};

export const updateAudioMarkers = async (
  animationId,
  audioMarkers,
  lockedPlaybackMarkerId = null,
) => {
  const animation = await request(
    getEndpoint("studio", "updateAudioMarkers", animationId),
    { body: { audioMarkers, lockedPlaybackMarkerId } },
  );
  return animation.data;
};

export const deleteAnimation = async (animationId) => {
  await request(getEndpoint("studio", "deleteAnimation", animationId));
};

export const getAnimations = async (query) => {
  const animations = await request(getEndpoint("studio", "getAnimations"), {
    query,
  });
  return animations.data;
};
